import { post } from "../../../js/http";
import Cookies from "js-cookie";
import axios from "axios";
import storage from "good-storage";
import { setMediaLen } from "../../../js/util";

$(document).ready(function () {
  layui.use(["upload", "laydate", "form", "layer", "util"], function () {
    var $ = layui.jquery,
      upload = layui.upload,
      laydate = layui.laydate,
      layer = layui.layer,
      form = layui.form,
      util = layui.util;
    // 点击直接上传图片
    //   upload.render({
    //     elem: "#headUpload",
    //     acceptMime: "image/*",
    //     url:
    //       axios.defaults.baseURL +
    //       "/ApiHome/ApiAction?_ControlName=SetUserFileByPC&_RegisterCode=" +
    //       Cookies.get("registerCode"),
    //     data: {
    //       type: 1 //上传相册照片
    //     },
    //     field: "image",
    //     choose: function(obj) {
    //       console.log("选择文件");
    //     },
    //     before: function(obj) {
    //       //预读本地文件示例，不支持ie8
    //       obj.preview(function(index, file, result) {
    //         //result  图片链接（base64）
    //         $("#headUpload").css({
    //           "background-image": "url(" + result + ")",
    //           "background-size": "cover",
    //           "background-position": "center center"
    //         });
    //       });
    //     },
    //     done: function(res) {
    //       console.log(res);
    //     },
    //     error: function() {
    //       console.log(res);
    //     }
    //   });
    $("#headUpload").click(function () {
      layer.open({
        type: 1,
        skin: "layer-custom",
        area: ["500px", ""],
        title: "",
        id: "headUploadCon",
        closeBtn: 2,
        content: $("#headUpload-con"),
      });
      var choose_file_flag = false;
      upload.render({
        elem: "#headUpload-sel",
        url:
          axios.defaults.baseURL +
          "/ApiHome/ApiAction?_ControlName=SetUserFileByPC&_RegisterCode=" +
          Cookies.get("registerCode"),
        data: {
          type: 1, //上传相册照片
        },
        auto: false,
        method: "post",
        bindAction: "#uploadimg-btn",
        field: "image",
        acceptMime: "image/*",
        size: 1024 * 6,
        choose: function (obj) {
          console.log("选择文件");
          //预读本地文件示例，不支持ie8
          obj.preview(function (index, file, result) {
            //result  图片链接（base64）
            $("#headUpload-sel").text("");
            $("#headUpload-sel").css({
              "background-image": "url(" + result + ")",
              "background-size": "cover",
              "background-position": "center center",
            });
            if (file.name.length > 0) {
              choose_file_flag = true;
            }
          });
        },
        done: function (res) {
          if (res.ReturnStatus) {
            layer.msg(res.MessageCN, { icon: 1 });
            setTimeout(() => {
              location.reload();
            }, 1500);
          } else {
            layer.msg(res.MessageCN, { icon: 2 });
          }
        },
        error: function () {
          console.log(res);
        },
      });
      $("#uploadimg-btn").click(function () {
        if (choose_file_flag == false) layer.msg("请选择图片", function () {});
      });
    });

    $(".voice-card .txt-btn").click(function () {
      uploadAudio();
    });
    $(".voice-card .addVoiceBtn").click(function () {
      uploadAudio();
    });

    function uploadAudio() {
      layer.open({
        type: 1,
        skin: "layer-custom",
        area: ["500px", ""],
        title: "",
        id: "voiceUploadCon",
        closeBtn: 2,
        content: $("#voiceUpload-con"),
      });
      var choose_file_flag = false;
      var voiceListView = $("#voiceList"),
        uploadVoiceList = upload.render({
          elem: "#voiceUpload-sel",
          url:
            axios.defaults.baseURL +
            "/ApiHome/ApiAction?_ControlName=PublishDynamicByPC&_RegisterCode=" +
            Cookies.get("registerCode"),
          data: {
            UserID: storage.get("userInfo").UserID,
            Type: 1,
            voicelength: null,
          },
          auto: false,
          method: "post",
          bindAction: "#uploadvoice-btn",
          field: "voice",
          accept: "audio",
          acceptMime: "audio/*",
          exts: "mp3|wav|wma|ape",
          size: 1024 * 10,
          choose: function (obj) {
            if ($("#voiceList tr").length >= 1) {
              return false;
            }
            var files = (this.files = obj.pushFile()); //将每次选择的文件追加到文件队列
            obj.preview(function (index, file, result) {
              if (file.name.length > 0) {
                choose_file_flag = true;
              }

              getTimes(file);
              function getTimes(file) {
                //获取录音时长
                var url = URL.createObjectURL(file);
                //经测试，发现audio也可获取视频的时长
                var audioElement = new Audio(url);

                var duration = 0;
                audioElement.addEventListener("loadedmetadata", function (
                  _event
                ) {
                  // 音频长度 单位秒
                  duration = audioElement.duration;
                  uploadVoiceList.config.data["voicelength"] = duration;
                  // console.log(duration / 60);
                });
              }

              var tr = $(
                [
                  '<tr id="upload-' + index + '">',
                  "<td>" + file.name + "</td>",
                  "<td>" + (file.size / 1014).toFixed(1) + "kb</td>",
                  "<td>等待上传</td>",
                  "<td>",
                  '<button class="layui-btn layui-btn-xs voice-reload layui-hide">重传</button>',
                  '<button class="layui-btn layui-btn-xs layui-btn-danger voice-delete">删除</button>',
                  "</td>",
                  "</tr>",
                ].join("")
              );

              //单个重传
              tr.find(".voice-reload").on("click", function () {
                obj.upload(index, file);
              });
              //删除
              tr.find(".voice-delete").on("click", function () {
                delete files[index]; //删除对应的文件
                tr.remove();
                uploadVoiceList.config.elem.next()[0].value = ""; //清空 input file 值，以免删除后出现同名文件不可选
              });

              voiceListView.append(tr);
            });
          },
          done: function (res) {
            if (res.ReturnStatus) {
              layer.msg(res.MessageCN, { icon: 1 });
              setTimeout(() => {
                location.reload();
              }, 1500);
            } else {
              layer.msg(res.MessageCN, { icon: 2 });
            }
          },
          error: function (res) {
            console.log(res);
          },
        });
      $("#uploadvoice-btn").click(function () {
        if (choose_file_flag == false) layer.msg("请选择音频", function () {});
      });
    }
    // function getTimes(file) {
    //   //获取录音时长
    //   var url = URL.createObjectURL(file);
    //   //经测试，发现audio也可获取视频的时长
    //   var audioElement = new Audio(url);

    //   var duration;
    //   audioElement.addEventListener("loadedmetadata", function(_event) {
    //     duration = audioElement.duration;
    //     console.log(duration);
    //     return duration;
    //     // console.log(duration / 60);
    //   });
    // }

    if (storage.get("userInfo").WaitAuditDataUrl) {
      // 1有无待审核头像
      $("#headUpload").css({
        "background-image":
          "url(" + storage.get("userInfo").WaitAuditDataUrl + ")",
        "background-size": "cover",
        "background-position": "center center",
      });
    } else if (storage.get("userInfo").DataUrl) {
      // 2有无头像
      $("#headUpload").css({
        "background-image": "url(" + storage.get("userInfo").DataUrl + ")",
        "background-size": "cover",
        "background-position": "center center",
      });
    }

    // 获取18年前的今天
    var pre = new Date();
    pre.setFullYear(pre.getFullYear() - 18);
    const curDay = util.toDateString(pre, "yyyy-MM-dd");
    const myBirstday = util.toDateString(
      storage.get("userInfo").Birthday,
      "yyyy-MM-dd"
    );
    laydate.render({
      elem: "#mpbirthday",
      value: myBirstday,
      max: curDay,
      btns: ["clear", "confirm"],
    });

    //获取省份
    getProvince();

    form.on("select(mpprovince)", function (data) {
      getCity({ ProvinceID: data.value });
    });

    function getProvince() {
      post("/ApiHome/ApiAction?_ControlName=GetCountryProvinceByPc").then(
        (res) => {
          if (res.ReturnStatus) {
            let provinceStr = "";
            res.Data.OnlyOneData.forEach((item, index) => {
              provinceStr +=
                "<option value=" +
                item.AutoID +
                ">" +
                item.ProvinceShortName +
                "</option>";
            });
            $("form select[name='mpprovince']").html(provinceStr);
            // 如果有省份
            if (storage.get("userInfo").AtProvinces) {
              $("form select[name='mpprovince']").val(
                storage.get("userInfo").AtProvinces
              );
            }
            form.render("select");
            // 如果有城市
            if (storage.get("userInfo").AtCities) {
              getCity({ ProvinceID: storage.get("userInfo").AtProvinces });
            }
          }
        }
      );
    }
    function getCity(data) {
      post("/ApiHome/ApiAction?_ControlName=GetCountryCityByPc", data).then(
        (res) => {
          if (res.ReturnStatus) {
            let cityStr = "";
            res.Data.OnlyOneData.forEach((item, index) => {
              cityStr +=
                "<option value=" +
                item.AutoID +
                ">" +
                item.CountryShortName +
                "</option>";
            });
            $("form select[name='mpcity']").html(cityStr);
            if (storage.get("userInfo").AtCities) {
              $("form select[name='mpcity']").val(
                storage.get("userInfo").AtCities
              );
            }
            form.render("select");
          }
        }
      );
    }

    //获取学历
    getEducational();
    function getEducational() {
      post("/ApiHome/ApiAction?_ControlName=GetAllTypes&parentId=10600").then(
        (res) => {
          if (res.ReturnStatus) {
            let EduStr = "";
            res.Data.OnlyOneData.forEach((item, index) => {
              EduStr +=
                "<option value=" +
                item.TypeValue +
                ">" +
                item.TypeName +
                "</option>";
            });
            $("form select[name='mpedu']").html(EduStr);
            $("form select[name='mpedu']").val(
              storage.get("userInfo").Education
            );
            form.render("select");
          }
        }
      );
    }
    //获取情感状态
    getEmotion();
    function getEmotion() {
      post("/ApiHome/ApiAction?_ControlName=GetAllTypes&parentId=10700").then(
        (res) => {
          if (res.ReturnStatus) {
            let EduStr = "";
            res.Data.OnlyOneData.forEach((item, index) => {
              EduStr +=
                "<option value=" +
                item.TypeValue +
                ">" +
                item.TypeName +
                "</option>";
            });
            $("form select[name='mpemotion']").html(EduStr);
            $("form select[name='mpemotion']").val(
              storage.get("userInfo").EmotionState
            );
            form.render("select");
          }
        }
      );
    }
    //获取个人特长
    // getSpeciality();
    // function getSpeciality() {
    //   post("/ApiHome/ApiAction?_ControlName=GetUserSpecialtyListByPC", {
    //     UserID: storage.get("userInfo").UserID,
    //     Type: 3 //个人资料
    //   }).then(res => {
    //     if (res.ReturnStatus) {
    //       console.log(res);
    //     }
    //   });
    // }
    $("#setSpecialty").click(function () {
      let selectList = $("#speciality-con span.active");
      let specialtyIDStr = "";
      if (selectList.length) {
        for (var i = 0; i < selectList.length; i++) {
          specialtyIDStr =
            specialtyIDStr + $(selectList[i]).attr("data-id") + ",";
        }
        post("/ApiHome/ApiAction?_ControlName=SetUserSpecialtyByPC", {
          specialtyids: specialtyIDStr.substring(0, specialtyIDStr.length - 1),
        }).then((res) => {
          if (res.ReturnStatus) {
            layer.msg(res.MessageCN, { icon: 1 });
            setTimeout(() => {
              window.location.reload();
            }, 1500);
          } else {
            layer.msg(res.MessageCN, { icon: 2 });
          }
        });
      } else {
        layer.msg("请选择您的特长", { icon: 2 });
      }
    });

    // 获取月薪
    getMonthlyPay();
    function getMonthlyPay() {
      post("/ApiHome/ApiAction?_ControlName=GetAllTypes&parentId=10800").then(
        (res) => {
          if (res.ReturnStatus) {
            let monPayStr = "";
            res.Data.OnlyOneData.forEach((item, index) => {
              monPayStr +=
                "<option value=" +
                item.TypeValue +
                ">" +
                item.TypeName +
                "</option>";
            });
            $("form select[name='mMonthSalary']").html(monPayStr);
            $("form select[name='mMonthSalary']").val(
              storage.get("userInfo").MonthSalary
            );
            form.render("select");
          }
        }
      );
    }
    // 个性签名
    if (storage.get("userInfo").IsTipsWaitAudit == 0) {
      // 有待审核数据
      $("#personalSignature").val(storage.get("userInfo").WaitAuditTips);
    } else {
      $("#personalSignature").val(storage.get("userInfo").MyTips);
    }

    $("#saveProfileBtn").click(function () {
      var postData = {
        UserID: storage.get("userInfo").UserID,
        Nick: $("#pNickName").val(),
        Birth: $("#mpbirthday").val(),
        Area:
          $("select[name=mpprovince]").val() +
          "," +
          $("select[name=mpcity]").val(),
        InCome: $("select[name=mMonthSalary]").val(),
        Height: $("#mHeight").val(),
        Introduce: $("#personalSignature").val(),
        Education: $("select[name=mpedu]").val(),
        Emotionstate: $("select[name=mpemotion]").val(),
      };
      post("/ApiHome/ApiAction?_ControlName=SetUserInfoByPC", postData).then(
        (res) => {
          if (res.ReturnStatus) {
            layer.msg(res.MessageCN, { icon: 1 });
            setTimeout(() => {
              location.reload();
            }, 1500);
          } else {
            layer.msg(res.MessageCN, { icon: 2 });
          }
        }
      );
    });
  });

  window.openSpecialityCon = function () {
    layer.open({
      type: 1,
      skin: "layer-custom",
      area: ["500px", ""],
      title: "",
      id: "specialityCon",
      closeBtn: 2,
      content: $("#speciality-con"),
      end: function () {
        $("#speciality-con").hide();
      },
    });
  };

  let audioSetInterval;
  window.playVoice = function (el) {
    window.clearInterval(audioSetInterval);
    SetTimeL();
    let vblist = $(".voice-box");

    if (el.getAttribute("data-media") == $("#audioPlayer").attr("src")) {
      //同一个音频
      if ($(el).hasClass("pause")) {
        $(el).removeClass("pause").addClass("playing");
        $("#audioPlayer")[0].play();
        audioSetInterval = setInterval(Func, 1000);
      } else {
        $(el).removeClass("playing").addClass("pause");
        $("#audioPlayer")[0].pause();
      }
    } else {
      $(el).removeClass("pause").addClass("playing");
      $("#audioPlayer").attr("src", el.getAttribute("data-media"));
      $("#audioPlayer")[0].play();
      audioSetInterval = setInterval(Func, 1000);
    }
    if (vblist.length) {
      for (var i = 0; i < vblist.length; i++) {
        if (
          vblist[i].getAttribute("data-media") != $("#audioPlayer").attr("src")
        ) {
          $(vblist[i]).removeClass("playing").addClass("pause");
        }
      }
    }

    function Func() {
      // 创建倒计时
      if (vblist.length) {
        for (var i = 0; i < vblist.length; i++) {
          if ($(vblist[i]).hasClass("playing")) {
            // 设置剩余时长
            let temp = Number(
              $(vblist[i]).find("label.timeL").attr("data-ctime")
            );
            if (temp - 1 >= 0) {
              $(vblist[i])
                .find("label.timeL")
                .attr("data-ctime", temp - 1);
              $(vblist[i])
                .find("label.timeL")
                .text(setMediaLen(temp - 1));
            }
          }
        }
      }
    }

    function SetTimeL() {
      let vblist = $(".voice-box");
      if (vblist.length) {
        for (var i = 0; i < vblist.length; i++) {
          $(vblist[i])
            .find("label.timeL")
            .text(setMediaLen(vblist[i].getAttribute("data-time")));
        }
      }
    }
    var audio = document.getElementById("audioPlayer");
    if (audio) {
      audio.loop = false;
      audio.addEventListener(
        "ended",
        function () {
          console.log("结束");
          SetTimeL();
          //清除倒计时
          window.clearInterval(audioSetInterval);
          let vblist = $(".voice-box");
          if (vblist.length) {
            for (var i = 0; i < vblist.length; i++) {
              if (
                vblist[i].getAttribute("data-media") ==
                $("#audioPlayer").attr("src")
              ) {
                $(vblist[i]).removeClass("playing").addClass("pause");
              }
            }
          }
          //在这个方法里写相应的逻辑就可以了
        },
        false
      );
    }
  };
});
